import { mat4 } from 'gl-matrix';
import { GenerationModelDetails } from '../dicom/dicomBase';
import { DicomRegistration } from '../dicom/dicomRegistration';

export class RigidRegistration {
    public readonly transformation: mat4;
    public readonly sourceFrameOfReferenceUid: string;
    public readonly targetFrameOfReferenceUid: string;
    public readonly dicomParent: DicomRegistration;
    public readonly contentLabel: string;

    constructor(
        sourceFrameOfReferenceUid: string,
        targetFrameOfReferenceUid: string,
        contentLabel: string,
        transformation: mat4,
        parent: DicomRegistration
    ) {
        this.sourceFrameOfReferenceUid = sourceFrameOfReferenceUid;
        this.targetFrameOfReferenceUid = targetFrameOfReferenceUid;
        this.contentLabel = contentLabel;
        this.transformation = transformation;
        this.dicomParent = parent;
    }

    public get dicomUid(): string {
        return this.dicomParent.sopInstanceUID;
    }

    public get generationModel(): GenerationModelDetails | undefined {
        return this.dicomParent.generationModel;
    }

    public get isNew(): boolean {
        return this.dicomParent.isNew;
    }

    public setExported(): void {
        this.dicomParent.setExported();
    }
}
